import React, { Component } from "react";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import axiosInstance from "../../../store/services/AxiosService";

export default class PenilaianStudent extends Component {
    constructor(props) {
        super(props);

        const ranges = {
            "0-10": 0,
            "10-20": 0,
            "20-30": 0,
            "30-40": 0,
            "40-50": 0,
            "50-60": 0,
            "60-70": 0,
            "70-80": 0,
            "80-90": 0,
            "90-100": 0,
        };

        const colors = [
            "#FF0000", // Red - Error
            "#FF3300", // Strong Orange
            "#FF6600", // Orange
            "#FF9900", // Yellow Orange
            "#FFCC00", // Yellow
            "#CCCC00", // Olive Yellow
            "#99CC00", // Light Yellow Green
            "#66CC00", // Lime Green
            "#33CC00", // Green
            "#009900", // Dark Green - Success
        ];

        const { listSchedule } = props;

        // Flatten and iterate over all scores
        Object.values(listSchedule).forEach((element) => {
            const score = parseFloat(element.student_answer.student_total_scores);

            // Determine the range for the score
            if (score >= 0 && score < 10) ranges["0-10"]++;
            else if (score >= 10 && score < 20) ranges["10-20"]++;
            else if (score >= 20 && score < 30) ranges["20-30"]++;
            else if (score >= 30 && score < 40) ranges["30-40"]++;
            else if (score >= 40 && score < 50) ranges["40-50"]++;
            else if (score >= 50 && score < 60) ranges["50-60"]++;
            else if (score >= 60 && score < 70) ranges["60-70"]++;
            else if (score >= 70 && score < 80) ranges["70-80"]++;
            else if (score >= 80 && score < 90) ranges["80-90"]++;
            else if (score >= 90 && score <= 100) ranges["90-100"]++;
        });

        const percentages = Object.values(ranges).map((count) => count);
        const result = percentages.map((percentage) => parseFloat(percentage));

        this.state = {
            activeTab: "tab1",
            series: [
                {
                    name: "Siswa",
                    data: result,
                },
            ],
            options: {
                chart: {
                    height: 100,
                    type: "bar",
                },
                plotOptions: {
                    bar: {
                        columnWidth: "50%",
                        borderRadius: 5,
                        dataLabels: {
                            position: "top",
                        },
                        distributed: true,
                    },
                },
                colors: colors,
                dataLabels: {
                    enabled: true,
                    offsetY: -20,
                },
                legend: {
                    show: false,
                },
                xaxis: {
                    categories: Object.keys(ranges),
                    labels: {
                        style: {
                            colors: colors,
                        },
                    },
                    position: "bottom",
                    tooltip: {
                        enabled: false,
                    },
                    title: {
                        text: "Kelompok Nilai",
                    },
                },
                yaxis: {
                    labels: {
                        tickAmount: 1,
                        show: true,
                    },
                    title: {
                        text: "Total Siswa",
                    },
                    max: Math.max(...result),
                },
                title: {
                    text: "Capaian Hasil Siswa dalam Grafik",
                    offsetY: 350,
                    align: "center",
                    style: {
                        color: "#444",
                    },
                },
            },
            scheduleData: null,
            dayaSerap: null,
            analisisButirSoal: null,
            processedData: [],
        };
    }

    switchTab = (tabName) => {
        this.setState({ activeTab: tabName });
    };

    componentDidMount() {
        const script = document.createElement("script");
        script.src = "assets/js/dataTable-content.js";
        script.async = true;
        document.body.appendChild(script);

        this.fetchScheduleData();
        this.fetchDayaSerapData();
        this.fetchAnalisisButirSoalData();
    }

    groupingScorePilgan(student) {
        let score = 0;
        Object.values(student.student_answer.case_parts).map((element) => {
            if (element.type_name === "pilihan ganda") {
                score = score + element.part_scores;
            }
            return score;
        });
        return score;
    }

    groupingScorePilganTrueFalse(student) {
        let score = 0;
        Object.values(student.student_answer.case_parts).map((element) => {
            if (element.type_name === "pilihan ganda benar salah") {
                score = score + element.part_scores;
            }
            return score;
        });
        return score;
    }

    groupingScoreEassayShort(student) {
        let score = 0;
        Object.values(student.student_answer.case_parts).map((element) => {
            if (element.type_name === "isian singkat") {
                score = score + element.part_scores;
            }
            return score;
        });
        return score;
    }

    groupingScorePilganKompleks(student) {
        let score = 0;
        Object.values(student.student_answer.case_parts).map((element) => {
            if (element.type_name === "pilihan ganda kompleks") {
                score = score + element.part_scores;
            }
            return score;
        });
        return score;
    }

    groupingScoreEssay(student) {
        let score = 0;
        Object.values(student.student_answer.case_parts).map((element) => {
            if (element.type_name === "uraian") {
                score = score + element.part_scores;
            }
            return score;
        });
        return score;
    }

    groupingScoreMenjodohkan(student) {
        let score = 0;
        Object.values(student.student_answer.case_parts).map((element) => {
            if (element.type_name === "menjodohkan") {
                score = score + element.part_scores;
            }
            return score;
        });
        return score;
    }

    fetchScheduleData() {
        // 1. Tambahkan proteksi: Jika listSchedule kosong atau undefined, hentikan fungsi
        if (!this.props.listSchedule || this.props.listSchedule.length === 0) {
            return;
        }

        // 2. Gunakan optional chaining untuk ekstra aman
        const school_id = this.props.listSchedule[0]?.school_id;

        // 3. Pastikan school_id dan schedule ada sebelum memanggil axios
        if (school_id && this.props.schedule) {
            const tipe = this.props.tipePenilaian || 'CP';
            axiosInstance.get(`/kompetensi-dasar/schedules/` + this.props.schedule + '/school/' + school_id + '?tipe=' + tipe)
                .then((res) => {
                    const list = res.data;
                    this.setState({
                        scheduleData: list,
                    });
                    this.processData();
                })
                .catch(error => console.error("Error fetching KD data:", error));
        }
    }

    fetchDayaSerapData() {
        // Pastikan ID schedule tersedia
        if (!this.props.schedule) return;

        const tipe = this.props.tipePenilaian || 'CP';
        axiosInstance.get(`/daya-serap/schedules/` + this.props.schedule + '?tipe=' + tipe)
            .then((res) => {
                const list = res.data;
                this.setState({
                    dayaSerap: list,
                });
            })
            .catch(error => console.error("Error fetching Daya Serap data:", error));
    }

    fetchAnalisisButirSoalData() {
        if (!this.props.schedule) return;

        axiosInstance.get(`/analisis-butir-soal/schedules/` + this.props.schedule)
            .then((res) => {
                const list = res.data;
                this.setState({
                    analisisButirSoal: list,
                });
            })
            .catch(error => console.error("Error fetching Analisis Butir Soal data:", error));
    }

    processData = () => {
        const { scheduleData } = this.state;
        const processedData = [];

        // 1. Group by student and assignment directly from backend rows
        if (scheduleData && scheduleData.length > 0) {
            scheduleData.forEach((item) => {
                processedData.push({
                    nisn: item.nisn || '-',
                    name: item.name || '-',
                    cp_description: item.kd_description,
                    tp_description: item.unit_description,
                    score: item.scores,
                    student_id: item.api_student_id,
                });
            });
        }

        // 2. Add students who have no scores at all
        const scoredStudentIds = new Set(processedData.map(p => p.student_id));
        if (this.props.listSchedule) {
            Object.values(this.props.listSchedule).forEach((student) => {
                const studentId = student.api_student_id;
                if (!scoredStudentIds.has(studentId)) {
                    processedData.push({
                        nisn: student.nisn || '-',
                        name: student.name || '-',
                        cp_description: 'Belum ditentukan',
                        tp_description: '-',
                        score: 0,
                        student_id: studentId,
                    });
                }
            });
        }

        // 3. Sort by Name then CP description
        processedData.sort((a, b) => {
            if (a.name !== b.name) return a.name.localeCompare(b.name);
            return a.cp_description.localeCompare(b.cp_description);
        });

        this.setState({ processedData });
    };

    render() {
        const { activeTab, processedData, dayaSerap, analisisButirSoal } = this.state;

        return (
            <div>
                {/* Tab Navigation */}
                <div className="tabs">
                    <button className={activeTab === "tab1" ? "active" : ""} onClick={() => this.switchTab("tab1")}>
                        Summary
                    </button>
                    <button className={activeTab === "tab2" ? "active" : ""} onClick={() => this.switchTab("tab2")}>
                        Detail
                    </button>
                    <button className={activeTab === "tab3" ? "active" : ""} onClick={() => this.switchTab("tab3")}>
                        Summary Nilai
                    </button>
                    <button className={activeTab === "tab4" ? "active" : ""} onClick={() => this.switchTab("tab4")}>
                        Analisis Daya Serap
                    </button>
                    <button className={activeTab === "tab5" ? "active" : ""} onClick={() => this.switchTab("tab5")}>
                        Analisis Butir Soal
                    </button>
                </div>

                {/* Tab Content */}
                <div className="tab-content">
                    {activeTab === "tab1" &&
                        <>
                            <h2 className="text-center m-4">GRAFIK HASIL</h2>
                            <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={350} />
                        </>
                    }
                    {activeTab === "tab2" && (
                        <>
                            <h2 className="text-center m-4">ANALISIS CAPAIAN PESERTA</h2>
                            <table className="table table-bordered text-center nowrap table-hover" id="dt_listStudentScoring" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <td className="th-table" style={{ width: "3.5rem" }}>
                                            No.
                                        </td>
                                        <td className="th-table">Nama</td>
                                        <td className="th-table">Pilgan</td>
                                        <td className="th-table">Pilgan B/S</td>
                                        <td className="th-table">Pilgan Kompleks</td>
                                        <td className="th-table">Uraian</td>
                                        <td className="th-table">Isian Singkat</td>
                                        <td className="th-table">Menjodohkan</td>
                                        <td className="th-table">Total Nilai</td>
                                        <td className="th-table">Waktu Selesai</td>
                                        <td className="th-table">Aksi</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.values(this.props.listSchedule).map((element, index) => (
                                        <tr key={element.api_student_id}>
                                            <td style={{ width: "3.5rem" }}>{index + 1}</td>
                                            <td>{element.name}</td>
                                            <td>{parseFloat(this.groupingScorePilgan(element)).toFixed(2)}</td>
                                            <td>{parseFloat(this.groupingScorePilganTrueFalse(element)).toFixed(2)}</td>
                                            <td>{parseFloat(this.groupingScorePilganKompleks(element)).toFixed(2)}</td>
                                            <td>{parseFloat(this.groupingScoreEssay(element)).toFixed(2)}</td>
                                            <td>{parseFloat(this.groupingScoreEassayShort(element)).toFixed(2)}</td>
                                            <td>{parseFloat(this.groupingScoreMenjodohkan(element)).toFixed(2)}</td>
                                            <td>{parseFloat(element.student_answer.student_total_scores).toFixed(2)}</td>
                                            <td>
                                                {element.updated_at 
                                                    ? new Date(element.updated_at).toLocaleString("id-ID", { 
                                                        year: "numeric", 
                                                        month: "short", 
                                                        day: "numeric", 
                                                        hour: "2-digit", 
                                                        minute: "2-digit" 
                                                    }).replace(/\./g, ':') 
                                                    : "-"}
                                            </td>
                                            <td>
                                                <Link to={`/assessment/${this.props.course}/${this.props.schedule}/assess/${element.api_student_id}`}>
                                                    <button className="btn btn-sm btn-outline-info mr-3">
                                                        <i className="mdi mdi-tooltip-edit"></i>
                                                        {/* Periksa */}
                                                        {element.student_answer.is_already_corrected === 1 ? "Periksa Kembali" : "Periksa"}
                                                    </button>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )}
                    {activeTab === "tab3" && (
                        <>
                            <h2 className="text-center m-4">HASIL TES PER SISWA</h2>
                            <table class="table table-bordered text-center nowrap table-hover" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: "#eee" }} className="th-table">No.</th>
                                        <th style={{ backgroundColor: "#eee" }} className="th-table">NISN</th>
                                        <th style={{ backgroundColor: "#eee" }} className="th-table">Nama</th>
                                        <th style={{ backgroundColor: "#eee" }} className="th-table">{(this.props.tipePenilaian === 'TP') ? 'Tujuan Pembelajaran' : 'Capaian Pembelajaran'}</th>
                                        <th style={{ backgroundColor: "#eee" }} className="th-table">Nilai</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {processedData && processedData.map((row, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{row.nisn}</td>
                                            <td>{row.name}</td>
                                            <td style={{ textAlign: 'left' }}>{row.cp_description}</td>
                                            <td>{parseFloat(row.score || 0).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )}
                    {activeTab === "tab4" && (
                        <>
                            <h2 className="text-center m-4">ANALISIS DAYA SERAP</h2>
                            <table class="table table-bordered text-center nowrap table-hover" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th className="th-table" colSpan="3"></th>
                                        <th className="th-table" style={{ backgroundColor: "#eee", borderBottomColor: "white" }} colSpan={3}>Jumlah Jawaban</th>
                                        <th className="th-table" colSpan="1"></th>
                                    </tr>
                                    <tr>
                                        <th style={{ backgroundColor: "#eee" }} className="th-table">{(this.props.tipePenilaian === 'TP') ? 'Tujuan Pembelajaran' : 'Capaian Pembelajaran'}</th>
                                        <th style={{ backgroundColor: "#eee" }} className="th-table">Materi</th>
                                        <th style={{ backgroundColor: "#eee" }} className="th-table">Indikator Soal</th>
                                        <th style={{ backgroundColor: "#eee", width: "10%" }} className="th-table">Benar</th>
                                        <th style={{ backgroundColor: "#eee", width: "10%" }} className="th-table">Salah</th>
                                        <th style={{ backgroundColor: "#eee", width: "10%" }} className="th-table">Tidak Jawab</th>
                                        <th style={{ backgroundColor: "#eee", width: "10%" }} className="th-table">Daya Serap</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dayaSerap && dayaSerap.map((i) => (
                                        <tr key={i.case_question_id}>
                                            <td style={{ width: "20%" }}>{i.kd_description || 'Belum ditentukan'}</td>
                                            <td style={{ width: "25%" }} dangerouslySetInnerHTML={{ __html: i.question }}></td>
                                            <td style={{ width: "15%" }}>{i.unit_description || '-'}</td>
                                            <td style={{ width: "10%" }}>{i.correct_count}</td>
                                            <td style={{ width: "10%" }}>{i.incorrect_count}</td>
                                            <td style={{ width: "10%" }}>{i.null_count}</td>
                                            <td style={{ width: "10%" }}>
                                                {i.total_answer > 0
                                                    ? (parseFloat(i.sum_score / i.total_answer) * 100).toFixed(2) + "%"
                                                    : "0.00%"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="mt-2 text-left">
                                <small><i>* Daya Serap = (Total Nilai Siswa / Total Siswa) * 100%</i></small>
                            </div>
                        </>
                    )}
                    {activeTab === "tab5" && (
                        <>
                            <h2 className="text-center m-4">ANALISIS BUTIR SOAL</h2>
                            <div className="table-responsive" style={{ overflowX: "auto" }}>
                                <table className="table table-bordered text-center table-hover" style={{ width: "100%", verticalAlign: "middle", tableLayout: "auto", borderCollapse: "collapse" }}>
                                    <thead style={{ backgroundColor: "#eee" }}>
                                        <tr>
                                            <th style={{ verticalAlign: "middle", border: "1px solid #dee2e6", backgroundColor: "#eee" }}>No.</th>
                                            <th style={{ verticalAlign: "middle", border: "1px solid #dee2e6", backgroundColor: "#eee" }}>No. Item</th>
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Prop. Correct<br/>(Item)</th>
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Biser<br/>(Item)</th>
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Point Biser<br/>(Item)</th>
                                            
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Opt.</th>
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Prop. Endorsing<br/>(Option)</th>
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Biser<br/>(Option)</th>
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Point Biser<br/>(Option)</th>
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Key</th>

                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Daya Pembeda</th>
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Tingkat Kesulitan</th>
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Efektifitas Option</th>
                                            <th style={{ border: "1px solid #dee2e6", backgroundColor: "#eee" }}>Status Soal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {analisisButirSoal ? analisisButirSoal.map((item, i) => {
                                            const opts = item.options;
                                            return (
                                                <React.Fragment key={i}>
                                                    {/* Row 1 (Option A) */}
                                                    <tr>
                                                        <td style={{ verticalAlign: "middle", fontWeight: "bold", backgroundColor: "#fafafa", border: "1px solid #dee2e6", borderBottom: "none" }}>{item.no_item}</td>
                                                        <td style={{ verticalAlign: "middle", fontWeight: "bold", backgroundColor: "#fafafa", border: "1px solid #dee2e6", borderBottom: "none" }}>{item.no_item}</td>
                                                        <td style={{ verticalAlign: "middle", backgroundColor: "#fafafa", border: "1px solid #dee2e6", borderBottom: "none" }}>{item.prop_correct.toFixed(3).replace('.', ',')}</td>
                                                        <td style={{ verticalAlign: "middle", backgroundColor: "#fafafa", border: "1px solid #dee2e6", borderBottom: "none" }}>{item.biser}</td>
                                                        <td style={{ verticalAlign: "middle", backgroundColor: "#fafafa", border: "1px solid #dee2e6", borderBottom: "none" }}>{item.point_biser !== '-' ? item.point_biser.toFixed(3).replace('.', ',') : '-'}</td>

                                                        <td style={{ border: "1px solid #dee2e6", verticalAlign: "middle" }}>{opts[0].opt_label}</td>
                                                        <td style={{ border: "1px solid #dee2e6", verticalAlign: "middle" }}>{opts[0].prop_endorsing.toFixed(3).replace('.', ',')}</td>
                                                        <td style={{ border: "1px solid #dee2e6", verticalAlign: "middle" }}>{opts[0].biser}</td>
                                                        <td style={{ border: "1px solid #dee2e6", verticalAlign: "middle" }}>{opts[0].point_biser}</td>
                                                        <td style={{ fontWeight: "bold", color: opts[0].key === '#' ? "green" : "inherit", border: "1px solid #dee2e6", verticalAlign: "middle" }}>{opts[0].key}</td>

                                                        <td style={{ verticalAlign: "middle", backgroundColor: "#fafafa", border: "1px solid #dee2e6", borderBottom: "none" }}>{item.tafsiran.daya_pembeda}</td>
                                                        <td style={{ verticalAlign: "middle", backgroundColor: "#fafafa", border: "1px solid #dee2e6", borderBottom: "none" }}>{item.tafsiran.tingkat_kesulitan}</td>
                                                        <td style={{ verticalAlign: "middle", backgroundColor: "#fafafa", border: "1px solid #dee2e6", borderBottom: "none" }}>{item.tafsiran.efektifitas_option}</td>
                                                        <td style={{ verticalAlign: "middle", whiteSpace: "pre-line", backgroundColor: "#fafafa", border: "1px solid #dee2e6", borderBottom: "none" }}>{item.tafsiran.status_soal}</td>
                                                    </tr>
                                                    
                                                    {/* Subsequent Rows (Options B, C, D, etc) */}
                                                    {opts.slice(1).map((opt, idx) => {
                                                        const isLast = idx === opts.length - 2; // slice(1) means last element is length - 2
                                                        const bBottom = isLast ? "1px solid #dee2e6" : "none";
                                                        return (
                                                            <tr key={idx}>
                                                                <td style={{ backgroundColor: "#fafafa", borderLeft: "1px solid #dee2e6", borderRight: "1px solid #dee2e6", borderTop: "none", borderBottom: bBottom }}></td>
                                                                <td style={{ backgroundColor: "#fafafa", borderLeft: "1px solid #dee2e6", borderRight: "1px solid #dee2e6", borderTop: "none", borderBottom: bBottom }}></td>
                                                                <td style={{ backgroundColor: "#fafafa", borderLeft: "1px solid #dee2e6", borderRight: "1px solid #dee2e6", borderTop: "none", borderBottom: bBottom }}></td>
                                                                <td style={{ backgroundColor: "#fafafa", borderLeft: "1px solid #dee2e6", borderRight: "1px solid #dee2e6", borderTop: "none", borderBottom: bBottom }}></td>
                                                                <td style={{ backgroundColor: "#fafafa", borderLeft: "1px solid #dee2e6", borderRight: "1px solid #dee2e6", borderTop: "none", borderBottom: bBottom }}></td>
                                                                
                                                                <td style={{ border: "1px solid #dee2e6", verticalAlign: "middle" }}>{opt.opt_label}</td>
                                                                <td style={{ border: "1px solid #dee2e6", verticalAlign: "middle" }}>{opt.prop_endorsing.toFixed(3).replace('.', ',')}</td>
                                                                <td style={{ border: "1px solid #dee2e6", verticalAlign: "middle" }}>{opt.biser}</td>
                                                                <td style={{ border: "1px solid #dee2e6", verticalAlign: "middle" }}>{opt.point_biser}</td>
                                                                <td style={{ fontWeight: "bold", color: opt.key === '#' ? "green" : "inherit", border: "1px solid #dee2e6", verticalAlign: "middle" }}>{opt.key}</td>
                                                                
                                                                <td style={{ backgroundColor: "#fafafa", borderLeft: "1px solid #dee2e6", borderRight: "1px solid #dee2e6", borderTop: "none", borderBottom: bBottom }}></td>
                                                                <td style={{ backgroundColor: "#fafafa", borderLeft: "1px solid #dee2e6", borderRight: "1px solid #dee2e6", borderTop: "none", borderBottom: bBottom }}></td>
                                                                <td style={{ backgroundColor: "#fafafa", borderLeft: "1px solid #dee2e6", borderRight: "1px solid #dee2e6", borderTop: "none", borderBottom: bBottom }}></td>
                                                                <td style={{ backgroundColor: "#fafafa", borderLeft: "1px solid #dee2e6", borderRight: "1px solid #dee2e6", borderTop: "none", borderBottom: bBottom }}></td>
                                                            </tr>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            );
                                        }) : (
                                            <tr>
                                                <td colSpan="14" className="text-center">Loading data...</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="mt-2 text-left">
                                <small><i>* Data dihitung berdasarkan total skor dan jawaban siswa.</i></small>
                            </div>
                        </>
                    )}
                </div>

                {/* Optional Styling */}
                <style jsx>{`
                    .tabs {
                        display: flex;
                        margin-bottom: 2rem;
                    }
                    .tabs button {
                        margin-right: 10px;
                        padding: 10px 20px;
                        cursor: pointer;
                        border: none;
                        background: #ddd;
                        border-radius: 5px;
                        transition: background 0.5s;
                    }
                    .tabs button.active {
                        background: #9a55ff;
                        color: white;
                    }
                    td, th {
                        white-space: normal !important;
                        word-wrap: break-word;
                    }
                `}</style>
            </div>
        );
    }
}
